import type { VoidFunctionComponent } from 'react';

import Button from '../../generic/Button/Button';

import styles from './ActivityFeedFooter.module.less';

type Props = {
  hasRows: boolean;
  hasNextPage?: boolean;
  isFetching: boolean;
  isError: boolean;
  fetchNextPage: () => unknown;
  refetch: () => unknown;
};

export const ActivityFeedFooter: VoidFunctionComponent<Props> = ({
  hasRows,
  hasNextPage,
  isFetching,
  isError,
  fetchNextPage,
  refetch,
}) => {
  //  A failed query keeps saying it failed while it is being retried, so wait for the retry before saying so again.
  const hasFailed = isError && !isFetching;
  //  A failed query still reports a next page, so stop on errors or the same page would be requested forever.
  const canFetchNextPage = Boolean(hasNextPage) && !isFetching && !isError;

  if (hasFailed) {
    //  With no rows the feed itself carries the error, so the footer only offers the retry.
    return (
      <div className={styles.footer} role={hasRows ? 'alert' : undefined}>
        {hasRows && "Couldn't load more."}
        <Button
          type="text"
          size="small"
          onClick={() => {
            //  Without a next page the failure was a refetch of the loaded pages, which fetchNextPage would not redo.
            void (hasRows && hasNextPage ? fetchNextPage() : refetch());
          }}
        >
          Try again
        </Button>
      </div>
    );
  }
  if (!hasNextPage) {
    return null;
  }
  return (
    <div className={styles.footer}>
      <Button
        type="outline"
        size="small"
        isDisabled={!canFetchNextPage}
        onClick={() => {
          void fetchNextPage();
        }}
      >
        Show more activity
      </Button>
    </div>
  );
};
